export const smartsightAPI = "https://prepaid.dopn.gov.in/connect/";
